import type { DataTableColumnVirtualizationState } from '../types';

export interface ColumnVirtualizationItem {
  end: number;
  index: number;
  start: number;
}

/** virtual item 범위로 중앙 컬럼 ID와 좌우 spacer를 계산 */
export function getColumnVirtualizationState({
  centerColumnIds,
  totalSize,
  virtualItems,
}: {
  centerColumnIds: readonly string[];
  totalSize: number;
  virtualItems: readonly ColumnVirtualizationItem[];
}): DataTableColumnVirtualizationState | undefined {
  const firstItem = virtualItems.at(0);
  const lastItem = virtualItems.at(-1);

  if (!firstItem || !lastItem) {
    return undefined;
  }

  const renderedCenterColumnIds = new Set(
    virtualItems
      .map(item => centerColumnIds[item.index])
      .filter((columnId): columnId is string => columnId !== undefined),
  );

  if (renderedCenterColumnIds.size === 0) {
    return undefined;
  }

  const leftSpacerWidth = Math.max(0, firstItem.start);
  const rightSpacerWidth = Math.max(0, totalSize - lastItem.end);

  return {
    renderedCenterColumnIds,
    ...(firstItem.index > 0 && {
      leftSpacer: {
        colSpan: firstItem.index,
        width: leftSpacerWidth,
      },
    }),
    ...(lastItem.index < centerColumnIds.length - 1 && {
      rightSpacer: {
        colSpan: centerColumnIds.length - lastItem.index - 1,
        width: rightSpacerWidth,
      },
    }),
  };
}

export function normalizeColumnVirtualizationOverscan(overscan: number | undefined): number {
  return Math.max(0, Math.floor(overscan ?? 3));
}
